type ClientKeys =
  | 'API_REST_URL'
  | 'MY_CAR_API_URL'
  | 'AFTERMARKET_API_URL'
  | 'PRICE_ESTIMATOR_API_URL'
  | 'SWITCH_BASE_URL'
  | 'LEASING_BASE_URL'
  | 'USER_TRACE_URL'
  | 'POSTـSTORAGE_URL'
  | 'CARMAA_URL'
  | 'BOOGH_URL'
  | 'PERSONAL_LISTING_URL'
  | 'CLUTCH_URL'
  | 'AUTO_DETAIL'
  | 'DEALERS_URL'
  | 'BUCK_URL'

export const servicesPathnames: { [key in ClientKeys]: string } = {
  API_REST_URL: '/rest/api',
  MY_CAR_API_URL: '/mycar/api',
  AFTERMARKET_API_URL: '/aftermarket/api',
  PRICE_ESTIMATOR_API_URL: '/priceestimator/api',
  SWITCH_BASE_URL: '/switch/api',
  USER_TRACE_URL: '/user-trace',
  LEASING_BASE_URL: '/leasing/api/v1',
  POSTـSTORAGE_URL: '/post-storage',
  CARMAA_URL: '/carmaa',
  PERSONAL_LISTING_URL: '/personal-listing',
  BOOGH_URL: '/boogh',
  AUTO_DETAIL: '/autodetail',
  CLUTCH_URL: '/clutch',
  DEALERS_URL: '/dealers/api',
  BUCK_URL: '/buck/api',
}

// SWITCH endpoints
export const SEND_OTP = `${servicesPathnames.SWITCH_BASE_URL}/auth/otp/send/`
export const CHECK_OTP = `${servicesPathnames.SWITCH_BASE_URL}/auth/otp/confirm/`
export const CURRENT_USER = `${servicesPathnames.SWITCH_BASE_URL}/users/current-user/`
export const REFRESH_TOKEN_URL = `${servicesPathnames.SWITCH_BASE_URL}/auth/refresh/`
export const SERVICES_LIST = `${servicesPathnames.SWITCH_BASE_URL}/services/`
export const UPDATE_CURRENT_USER = `${servicesPathnames.SWITCH_BASE_URL}/users/current-user/`
export const UPLOAD_MEDIA = `${servicesPathnames.SWITCH_BASE_URL}/media/`
export const LOGOUT_API = `${servicesPathnames.SWITCH_BASE_URL}/auth/logout/`

// BOOGH endpoints
export const PUSH_TOKEN = `${servicesPathnames.BOOGH_URL}/api/push_token/`
export const INVALIDATE_PUSH_TOKEN = `${servicesPathnames.BOOGH_URL}/api/push_token`

// Karnameh rest endpoints
export const SEARCH_BRAND_MODELS = `${servicesPathnames.API_REST_URL}/find_cars/v1/search`
export const INSPECTION_ORDERS = `${servicesPathnames.API_REST_URL}/evaluation/v1/mycar/inspections`
export const CONTACT_US = `${servicesPathnames.API_REST_URL}/contact-us`

// KARNAMEH API2 end points
export const RELATED_CAR_POSTS = `${servicesPathnames.POSTـSTORAGE_URL}/car-posts/car-post-related/`

// My Car endpoints
export const CAR_PROFILE = `${servicesPathnames.MY_CAR_API_URL}/car-profiles/`
export const INSPECTION_REPORT = `${servicesPathnames.MY_CAR_API_URL}/inspection/`

// Estimator end points
export const PRICE_ESTIMATOR = `${CAR_PROFILE}/estimate/`
export const ESTIMATOR_BRAND_MODELS = `${servicesPathnames.MY_CAR_API_URL}/priceestimator/brand-models/`

// After market end points
export const REPORT_DETAIL_URL = `${servicesPathnames.MY_CAR_API_URL}/aftermarket/internal/order/`
export const REPORTS_URL = `${servicesPathnames.AFTERMARKET_API_URL}/internal/orders/?state=done&has_report=true`
export const AFTERMARKET_ORDERS = `${servicesPathnames.AFTERMARKET_API_URL}/public/orders`

export const HISTORY_SERVICES = `${servicesPathnames.MY_CAR_API_URL}/services/`
export const HISTORY_ORDERS = `${servicesPathnames.MY_CAR_API_URL}/orders/`

// Notifications list end points
export const NOTIFICATIONS_LIST = `${servicesPathnames.BOOGH_URL}/api/in_app_notif/`

// Price Report
export const PRICE_REPORT = `${servicesPathnames.MY_CAR_API_URL}/priceestimator/pricing_report/user-pricing-report`
export const PRICE_REPORT_DETAILS = `${servicesPathnames.MY_CAR_API_URL}/priceestimator/pricing_report/mycar`

// Post Storage end points
export const STATES_LIST = `${servicesPathnames.POSTـSTORAGE_URL}/car-posts/states/`
